<template>
  <div class="header">
    <div class="top">
      <span>
        <b>{{ song.title }}</b> ({{ song.year }})
      </span>
    </div>
    <div class="bottom">
      <span
        v-if="authors.length > 0"
        class="artist" 
      >
        <span class="icon is-small">
          <i class="mdi mdi-pencil" />
        </span>
        <a
          role="button"
          @click="toArtist(authors[0])"
        >{{ $truncate(authors[0].name) }} </a>
        <b-tooltip
          v-if="authors.length > 1"
          :label="`Written by ${listText(authors.map(i => i.name))}`"
          type="is-dark"
          multilined
        >
          <span> (...)</span>
        </b-tooltip>
      </span>
      <span
        v-if="composers.length > 0"
        class="artist"
      >
        <span class="icon is-small">
          <i class="mdi mdi-music" />
        </span>
        <a
          role="button"
          @click="toArtist(composers[0])"
        >{{ $truncate(composers[0].name) }} </a>
        <b-tooltip
          v-if="composers.length > 1"
          :label="`Composed by ${listText(composers.map(i => i.name))}`"
          type="is-dark"
          multilined
        >
          <span> (...)</span>
        </b-tooltip>
      </span>
      <span
        v-if="interprets.length > 0"
        class="artist"
      >
        <span class="icon is-small">
          <i class="mdi mdi-microphone" />
        </span>
        <a
          role="button"
          @click="toArtist(interprets[0])"
        >{{ $truncate(interprets[0].name) }} </a>
        <b-tooltip
          v-if="interprets.length > 1"
          :label="`Sung by ${listText(interprets.map(i => i.name))}`"
          type="is-dark"
          multilined
        >
          <span> (...)</span>
        </b-tooltip>
      </span>
    </div>
  </div>
</template>

<script>

import { toArtist } from "@/services/navigator.js";

export default {
	props: {
		song: {
			required: true,
			type: Object
		},
		artist: {
			required: true,
			type: Object
		}
	},
	computed: {
    
		authors () {
			let ids = this.song.author_ids.filter(id => id != this.artist.id);
            
			if (this.artist != null && this.song.author_ids.filter(id => id == this.artist.id).length > 0) {
				ids.unshift(this.artist.id);
			}

			return ids.map(id => {
				return this.$store.state.artists[id]; 
			});
		},
		interprets () {
			let ids = this.song.interpret_ids.filter(id => id != this.artist.id);
            
			if (this.artist != null && this.song.interpret_ids.filter(id => id == this.artist.id).length > 0) {
				ids.unshift(this.artist.id);
			}

			return ids.map(id => {
				return this.$store.state.artists[id]; 
			});
		},
		composers () {
			let ids = this.song.composer_ids.filter(id => id != this.artist.id);
            
			if (this.artist != null && this.song.composer_ids.filter(id => id == this.artist.id).length > 0) {
				ids.unshift(this.artist.id);
			}

			return ids.map(id => {
				return this.$store.state.artists[id]; 
			});
		},
	},
	methods: {
		toArtist (artist) {
			toArtist(artist.id);
		},
		listText (list) {
			if (list.length < 2) {
				return list[0];
			}

			let string = "";

			for (let i = 0; i < list.length; i++) {
				string += list[i];
				if (i < list.length - 2) {
					string += ", ";
				} else if (i == list.length - 2) {
					string += " et ";
				}
			}

			return string;
		}
	},
};
</script>

<style lang="scss">
.header {
  display: block;
  box-shadow: 1px 1px 3px rgba(0,0,0,0.1);
  z-index: 2;
  position: relative;
  font-size: 0.9rem;

  .top {
    border-bottom: 1px solid #f1f1f1;
  }

  .top, .bottom {
    height: 35px;
    padding-left: 0.7rem;
    padding-right: 0.7rem;
    display: flex;
    align-items: center;
  }

  .artist {

    display: block;
    flex-grow: 0;
    flex-shrink: 1;

    font-size: 0.7rem;

    &:not(:last-child) {
      margin-right: 0.5rem;
    }

    .icon {
      margin-right: 0.25rem;
    }

    a {
      color: #333;
      text-decoration: underline;
    }
  }
}
</style>